import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { loginbg, Logo2 } from "../constant/imgages";
import { Checkbox, message } from "antd";
import { postRequest } from "../service/index";
import { updateLocalStorageData } from "../utils/localStorage";
import { jwtDecode } from "jwt-decode";
import ForgotPasswordModal from "../modal/forgot-password-modal";
import OTPVerificationModal from "../modal/otp-verification-modal";
import ResetPasswordModal from "../modal/reset-password-modal";


const Signin = () => {

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    emailAddress: "",
    password: ""
  });

  // Forgot password modal states
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await postRequest("/api/companies/login", formData);
      if (response.token) {
        updateLocalStorageData({
          token: response.token
        });
        
        // Store user data in localStorage as expected by navbar
        const decodedToken = jwtDecode(response.token);
        console.log("decodedToken",decodedToken)
        // Store the decoded user data in localStorage as "data"
        localStorage.setItem("data", JSON.stringify({
          user: decodedToken,
          token: response.token
        }));
        
        message.success("Login successful!");
        if (decodedToken.role === "companyadmin") {
          navigate("/adminDashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        message.error(response.error || "Login failed. Please check your credentials.");
      }
    } catch (error) {
      message.error("An error occurred during login.");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Forgot password handlers
  const handleForgotPasswordClick = () => {
    setForgotPasswordModal(true);
  };

  const handleEmailSubmitted = (email) => {
    setUserEmail(email);
    setForgotPasswordModal(false);
    setOtpModal(true);
  };

  const handleOTPVerified = (email) => {
    setUserEmail(email);
    setOtpModal(false);
    setResetPasswordModal(true);
  };

  const handlePasswordReset = () => {
    setResetPasswordModal(false);
    setUserEmail("");
    message.success("Password reset successfully! Please login with your new password.");
  };

  const handleModalCancel = () => {
    setForgotPasswordModal(false);
    setOtpModal(false);
    setResetPasswordModal(false);
    setUserEmail("");
  };

  return (
    <main className="loginapp fixed w-full h-full">
      <div className="loginBoxes">
        <ul className="loginbox">
          <li className="h-16 w-16"></li>
          <li className="h-20 w-20"></li>
          <li className="h-24 w-24"></li>
          <li className="h-16 w-16"></li>
          <li className="h-18 w-18"></li>
          <li className="h-22 w-22"></li>
          <li className="h-14 w-14"></li>
          <li className="h-26 w-26"></li>
        </ul>
      </div>

      <div className="min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:flex lg:w-1/2">
          <img
            src={loginbg} 
            alt="Login illustration"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right side login form */}
        <div className="w-full lg:w-1/2 flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-xl w-full bg-white rounded-lg shadow-lg p-12">
            <div className="flex flex-col items-center">
              <img src={Logo2} alt="Company Logo" className="h-40 w-auto mb-8" />
              <h2 className="text-center text-3xl font-extrabold text-gray-900">
                Sign in to your account
              </h2>
            </div>
            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div className="rounded-md shadow-sm -space-y-px">
                <div>
                  <label htmlFor="emailAddress" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="emailAddress"
                    name="emailAddress"
                    type="emailAddress"
                    required
                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                    placeholder="Email address"
                    value={formData.emailAddress}
                    onChange={handleChange}
                  />
                </div>
                <div className="relative">
                  <label htmlFor="password" className="sr-only">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    required
                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5 text-gray-400" />
                    ) : (
                      <Eye className="h-5 w-5 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <Checkbox id="remember-me">Remember me</Checkbox>
                </div>

                <div className="text-sm">
                  <button 
                    type="button"
                    onClick={handleForgotPasswordClick}
                    className="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
                  >
                    Forgot your password?
                  </button>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                >
                  {loading ? "Signing in..." : "Sign in"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Forgot Password Modals */}
      <ForgotPasswordModal
        visible={forgotPasswordModal}
        onCancel={handleModalCancel}
        onEmailSubmitted={handleEmailSubmitted}
      />
      
      <OTPVerificationModal
        visible={otpModal}
        onCancel={handleModalCancel}
        email={userEmail}
        onOTPVerified={handleOTPVerified}
      />
      
      <ResetPasswordModal
        visible={resetPasswordModal}
        onCancel={handleModalCancel}
        email={userEmail}
        onPasswordReset={handlePasswordReset}
      />
    </main>
  );
};

export default Signin;
